<template>
    <div>
        <el-breadcrumb>
            <el-breadcrumb-item style="padding-top: 30px;padding-bottom: 30px"><span style="font-weight: bolder;">快照持仓数据</span></el-breadcrumb-item>
        </el-breadcrumb>
        <el-form label-width="150px" :inline="true" :model="snapCondition" ref="snapForm">
            <el-form-item label="币种" prop="coinType" :rules="[{required: true, message: '请输入币种', trigger: 'blur'}]">
                <el-input v-model="snapCondition.coinType"></el-input>
            </el-form-item>
            <el-form-item label="档位" prop="grade" :rules="[{required: true, message: '请输入档位', trigger: 'blur'}]">
                <el-input v-model="snapCondition.grade"></el-input>
            </el-form-item>
            <el-form-item label="快照时间" prop="snapTime" :rules="[{required: true, message: '请输入快照时间', trigger: 'blur'}]">
                <el-date-picker v-model="snapCondition.snapTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySnapPosition">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="snapPosition">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="tapPosition" label="档位"></el-table-column>
            <el-table-column prop="numberPeople" label="人数"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import './store';
    import {mapState,mapActions} from 'vuex';
    export default {
        name: "snapPosition",
        data() {
            return {
                snapCondition:{
                    snapTime:'',
                    coinType:'',
                    grade:1000
                }
            }
        },
        computed: {
            ...mapState('tradeStatistic',['snapPosition'])
        },
        methods:{
            ...mapActions('tradeStatistic',['buildSnapPosition']),
            querySnapPosition() {
                this.$refs['snapForm'].validate(valid => {
                    if (valid) {
                        this.buildSnapPosition(this.snapCondition);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>